import {Injectable} from '@angular/core';
import {AbstractTuiPortalService} from '@taiga-ui/cdk';

@Injectable()
export class TuiEditorPortalService extends AbstractTuiPortalService {}
